import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  loginRequest,
  silentRequest,
  tokenRequest,
} from "../helpers/authConfig";
import { loginWithAad, refreshJwtByAad, authActions } from "../../../store";
import { useMsal } from "@azure/msal-react";
import { jwtDecode } from "jwt-decode";

export default function LoginAAD() {
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    var jwttoken = localStorage.getItem("jwtToken");
    if (jwttoken) {
      refreshToken(jwttoken).catch(() => {
        // Refresh başarısız olursa eski token temizle, login ekranı görünsün
        dispatch(authActions.resetLogin());
      });
    }
    getAccounts();
  }, []);

  const refreshToken = async (jwttoken) => {
    try {
      var now = new Date();
      var jwtDecoded = jwtDecode(jwttoken);
      var jwtDate = new Date(jwtDecoded.exp * 1000);
      if (now >= jwtDate) {
        var accessToken = await acquireToken();
        if (accessToken) {
          await dispatch(
            refreshJwtByAad({
              email: accessToken.account.username,
              token: accessToken.accessToken,
            })
          ).unwrap();
        }
      }
    } catch (err) {
      console.warn("Token yenileme başarısız:", err);
      throw err; // useEffect catch bloğu yakalsın
    }
  };

  const isIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ") > -1;
    const msie11 = ua.indexOf("Trident/") > -1;
    return msie || msie11;
  };

  const getAccounts = () => {
    const currentAccounts = instance.getAllAccounts();
    if (currentAccounts === null) {
      console.warn("No accounts detected!");
      return;
    } else if (currentAccounts.length > 1) {
      console.warn("Multiple accounts detected.");
      const account = instance.getAccount({});
      instance.setActiveAccount(account);
    } else if (currentAccounts.length === 1) {
      const account = instance.getAccount({});
      instance.setActiveAccount(account);
    }
  };

  const handleResponse = (response) => {
    if (response !== null) {
      instance.setActiveAccount(response.account);
    } else {
      getAccounts();
    }
  };

  const acquireToken = async () => {
    silentRequest.account = instance.getAccount({});
    return instance.acquireTokenSilent(silentRequest).catch((error) => {
      console.warn(
        "silent token acquisition fails. acquiring token using interactive method"
      );
      if (error) {
        // fallback to interaction when silent call fails
        tokenRequest.account = instance.getAccount({});

        return instance
          .acquireTokenPopup(tokenRequest)
          .then(handleResponse)
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.warn(error);
      }
    });
  };

  const login = async () => {
    // Start loading immediately when button is clicked
    dispatch(authActions.setLoading(true));
    
    try {
      await instance.initialize();
      await instance.handleRedirectPromise();
      if (isIE()) {
        return instance.loginRedirect();
      }
      await instance
        .loginPopup(loginRequest)
        .then(handleResponse)
        .then(getUserProfile)
        .catch((err) => {
          console.log(err);
          // Stop loading if popup is cancelled or error occurs
          dispatch(authActions.setLoading(false));
        });
    } catch (err) {
      console.error("Azure AD login error:", err);
      // Stop loading on error
      dispatch(authActions.setLoading(false));
    }
  };

  const getUserProfile = async () => {
    try {
      var accessToken = await acquireToken();
      if (accessToken) {
        // Loading already started, now dispatch login
        // Don't use .unwrap() here to avoid double error handling
        const result = await dispatch(
          loginWithAad({
            email: accessToken.account.username,
            token: accessToken.accessToken,
          })
        );
        
        // If login failed, loading will be stopped by reducer
        if (loginWithAad.rejected.match(result)) {
          // Redux will handle stopping loading via rejected state
          console.error("Login failed:", result.error);
        }
      } else {
        // No access token, stop loading
        dispatch(authActions.setLoading(false));
      }
    } catch (err) {
      console.error("Azure AD getUserProfile error:", err);
      // Stop loading on unexpected error
      dispatch(authActions.setLoading(false));
    }
  };

  return (
    <button
      type="button"
      className="modern-aad-button k-button"
      onClick={login}
    >
      <i className="fab fa-microsoft"></i>&nbsp; {t("azure-ad-login-button")}
    </button>
  );
}
